











































import { defineComponent } from '@nuxtjs/composition-api';
import { focus } from '@shared/ui/utilities/directives';
export default defineComponent({
  name: 'BaseRadio',
  directives: {
    focus,
  },
  model: {
    prop: 'selected',
    event: 'change',
  },
  props: {
    name: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    details: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: [String, Boolean],
      default: false,
    },
  },
  computed: {
    isChecked(): any {
      return this.value === this.selected || this.selected === true;
    },
  },
  methods: {
    changeHandler() {
      this.$emit('change', this.value);
    },
    inputHandler() {
      this.$emit('input', this.value);
    },
  },
});
